
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, RefreshCw } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Function to handle refresh and return to previous page
  const handleRefresh = () => {
    window.location.href = "/";
  };

  // Function to go back to previous page
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="text-center max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <h1 className="text-3xl font-bold text-tribal-secondary mb-2">Page Not Found</h1>
        <p className="text-lg text-gray-600 mb-6">
          The page you were looking for doesn't exist or an error occurred.
        </p>
        
        <div className="space-y-3">
          <Button 
            onClick={handleGoBack}
            variant="outline" 
            className="w-full flex items-center justify-center"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
          
          <Button 
            onClick={handleRefresh}
            className="w-full bg-tribal-primary hover:bg-tribal-primary/90 flex items-center justify-center"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Return to Home
          </Button>
        </div>
        
        <p className="mt-6 text-sm text-gray-500">
          If you were refreshing the page, use the buttons above to navigate back.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
